import { render } from "./button.vue?vue&type=template&id=7fc1bcac&scoped=true"
import script from "./button.vue?vue&type=script&lang=js"
export * from "./button.vue?vue&type=script&lang=js"

import "./button.vue?vue&type=style&index=0&id=7fc1bcac&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7fc1bcac"

export default script